import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import ag1 from "../../../assets/ag1.png";
import email from "../../../assets/message_icon.png";
import mailWhite from "../../../assets/mailWhite.png";
import call from "../../../assets/call_icon.png";
import shareRed from "../../../assets/shareRed.png";
import { BACKEND_BASE_URL } from "../../../apiInstances/baseurl";
import { MdEmail, MdIosShare } from "react-icons/md";
import { FaPhoneAlt, FaRegStar, FaStar, FaStarHalfAlt } from "react-icons/fa";
import HeaderImg from "../../../assets/findAgent/headerImg.webp";
import ShareModal from "./ShareModal";

const AgencyConnectCard = ({
  AgencyData,
  handleClick,
  totalaverage,
  reviewlength,
}) => {
  const [showShareModal, setShowShareModal] = useState(false);
  const agency = AgencyData?.[0];
  const rating = Math.min(5, Math.max(0, Number(totalaverage) || 0));
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating - fullStars >= 0.5;

  return (
    <>
      <div className="bg-[#F4F4F4] p-4 rounded-2xl w-full max-w-[360px]">
        <div className="bg-white rounded-2xl overflow-hidden shadow-sm">

          {/* Top Header */}
          <div
            className={`flex justify-center items-center py-4 ${agency?.primary_color ? "" : "bg-black"}`}
            style={agency?.primary_color ? { backgroundColor: agency.primary_color } : undefined}
          >
            <img
              src={agency?.agencyLargeLogo || HeaderImg}
              alt="agency logo"
              className="h-6 object-contain"
            />
          </div>

          {/* Body */}
          <div className=" px-4 xl:px-6 py-4 xl:py-8 text-center">

            {/* Agency Name */}
            <h2 className="text-xl xl:text-2xl font-semibold text-[#1A1A2E] leading-snug">
              {agency?.principal_name}
            </h2>

            {/* Rating */}
            <div className="flex justify-center items-center gap-1 mt-4">
              {Array.from({ length: 5 }).map((_, i) => {
                if (i < fullStars) {
                  return (
                    <FaStar key={i} className="text-[#B6C61A] text-xl shrink-0" />
                  );
                }
                if (i === fullStars && hasHalfStar) {
                  return (
                    <FaStarHalfAlt
                      key={i}
                      className="text-[#B6C61A] text-xl shrink-0"
                    />
                  );
                }
                return (
                  <FaRegStar key={i} className="text-[#D1D5DB] text-xl shrink-0" />
                );
              })}
            </div>

            {/* Review Count */}
            <p className="text-gray-500 text-sm mt-3">
              {reviewlength} reviews
            </p>

            {/* Buttons */}
            <div className="flex flex-col gap-4 mt-8">

              {/* Primary CTA */}
              <button
                onClick={() => handleClick("Contact")}
                className="w-full py-3 rounded-full text-white font-medium text-sm xl:text-base transition bg-[#097FE6]"
              >
                Request a free appraisal
              </button>

              {/* Call Button */}
              <a
                href={`tel:${agency?.mobile_number}`}
                rel="noopener noreferrer"
                className="w-full flex items-center justify-center gap-2 py-3 rounded-full border border-gray-300 text-[#1A1A2E] font-medium bg-white hover:bg-gray-50 transition text-sm xl:text-base"
              >
                <FaPhoneAlt className="text-sm" />
                Call Agency
              </a>

              {/* Enquire Button */}
              <button
                onClick={() => handleClick("Contact")}
                className="w-full flex items-center justify-center gap-2 py-3 rounded-full border border-gray-300 text-[#1A1A2E] font-medium bg-white hover:bg-gray-50 transition text-sm xl:text-base"
              >
                <MdEmail className="text-lg" />
                Enquire
              </button>
            </div>
          </div>
        </div>
      </div>

      {showShareModal && (
        <ShareModal
          agency={AgencyData[0]}
          onClose={() => setShowShareModal(false)}
        />
      )}
    </>
  );
};

export default AgencyConnectCard;
